import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { formatConditionToNaturalLanguage } from "../AiPlanPage/EnhancedTaggingRule/formatConditionNaturalLanguage";
import type {
  ConditionalTagResultDetail,
  TaggingResultDetailRequest,
  TagOrigin,
} from "../../services/taggingResultsService";
import { useAiHubListFiltersStore } from "./aiHubListFiltersStore";
import { AI_HUB_TAB_LABELS, readTaggingResultDetailQuery } from "./constants";

export type { TagOrigin };
export type {
  AutoTagResultDetail,
  ConditionalTagResultDetail,
} from "../../services/taggingResultsService";

export const MISSING_CLASSIFICATION_DETAIL_QUERY_MESSAGE =
  `Object type is required to load this ${AI_HUB_TAB_LABELS.taggingResult}.`;

export const MISSING_CONDITIONAL_DETAIL_QUERY_MESSAGE =
  `Object type is required to load this ${AI_HUB_TAB_LABELS.conditionalTaggingResult}.`;

export function displayOrDash(value: string): string {
  return value.trim() || "-";
}

export function isTaggingResultDetailRequestReady(
  query: TaggingResultDetailRequest,
): boolean {
  return Boolean(query.objectId.trim() && query.objectType.trim());
}

export function useTaggingResultDetailRequest(
  listKey: "taggingResult" | "conditionalTaggingResult",
): TaggingResultDetailRequest {
  const { resultId = "" } = useParams();
  const [searchParams] = useSearchParams();
  const listFilters = useAiHubListFiltersStore((state) => state[listKey]);
  return useMemo(() => {
    const query = readTaggingResultDetailQuery(searchParams);
    return {
      objectId: resultId.trim(),
      objectType: query.objectType || listFilters.objectType.trim(),
      objectSubType: query.objectSubType || listFilters.objectSubType.trim(),
      version: query.version,
    };
  }, [
    listFilters.objectSubType,
    listFilters.objectType,
    resultId,
    searchParams,
  ]);
}

export function formatMatchedCondition(condition: unknown): string {
  return formatConditionToNaturalLanguage(condition);
}
export function conditionalStatusPresentation(
  status: ConditionalTagResultDetail["status"],
): { label: string; tone: "green" | "blue" } {
  if (status === "inProgress") {
    return { label: "In Progress", tone: "blue" };
  }
  return { label: "Complete", tone: "green" };
}
